import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {GjeldendeTidssone} from "../tjenester/i18n/GjeldendeTidssone";
import {ZonedDateTimeSerialisert} from "../tjenester/ressurser/generertNg2HttpKlient";
import {lesDateEllerZonedDateTimeSerialisert, lesZonedDateTimeSerialisertOpt, plainTimeFraZonedDateTime} from "../støttefunksjoner/temporal";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import ZonedDateTime = Temporal.ZonedDateTime;
import PlainTime = Temporal.PlainTime;

/**
 * Leser angitt verdi som ZonedDateTime og konverterer så denne til PlainTime i brukers tidssone.
 * Angitt dato kan være av typen ZonedDateTime, ZonedDateTimeSerialisert eller Date.
 */
@Pipe({name: 'zoneddatetimeSomPlainTime', pure: true, standalone: true})
export class ZoneddatetimeSomPlainTimePipe implements PipeTransform {
    constructor(private gjeldendeTidssone: GjeldendeTidssone) {
    }

    transform(datoOgKlokkeslett: ZonedDateTime | ZonedDateTimeSerialisert | Date | null): PlainTime | null {
        const zonedDateTime = (datoOgKlokkeslett instanceof ZonedDateTime) ? datoOgKlokkeslett : lesDateEllerZonedDateTimeSerialisert(datoOgKlokkeslett);
        if (erNil(zonedDateTime)) return null;
        return plainTimeFraZonedDateTime(zonedDateTime, this.gjeldendeTidssone.brukersTidssone());
    }
}
